import {request, oldRequest} from '@/assets/js/request.js'

export function maxusLogin(data) {
  return oldRequest({
    method: 'post',
    url: 'web/rv2go-auth-service/user/maxusLogin',
    data: JSON.stringify(data),
  })
}

export function getUserInfoV1() {
  return oldRequest({
    method: 'get',
    url: 'web/rv-rental-mobile-api/getUserByMobile',
    data: {},
  })
}

export function bindPopupWindow(data) {
  return oldRequest({
    method: 'post',
    url: 'web/rv-base-facade/v1/bindPopupWindow',
    data: JSON.stringify(data),
  })
}

export function accessTokenLogin() {
  return oldRequest({
    method: 'post',
    url: 'auth/v1/accessToken',
    data: JSON.stringify(data),
  })
}

export function login() {
  return oldRequest({
    method: 'get',
    url: 'v1/login',
    data: data,
  })
}



// WEBPACK FOOTER //
// ./src/api/cust.js